export const appID = "N22AHQO9e93hexjdqJZnXlFzUWEzCHzZjD022IOI";
export const apiKey = "LK30hsZQPIoCbOJjzqxKABy1uBfBC1nfLHWimxcR"; //client key
// export const apiKey = "rdGPclTXv2ofqoxV2ffSr823VDnwAnCV5O7OZmKZ"; //rest key
// masterKey = "jcDjwZ1jriVOhYUGXCYmwJMXMli9wYMpvToqJ8Dc"
export const endPoint = "https://parseapi.back4app.com/classes/Projects";
export const formEndpoint = "https://formspree.io/xjvazkkl";